import globalize from './internal/globalize';
export default globalize('params', {});



// WEBPACK FOOTER //
// src/js/aui/params.js